import { Tag } from '@eventbrite/eds-tag';
import { gettext } from '@eventbrite/i18n';
import { $FixMe } from '@eventbrite/ts-utils';
import shuffle from 'lodash/shuffle';
import React from 'react';
import { TagGroup } from './TagGroup';

interface TagSuggestionsProps {
    trackGAEvent?: Function;
    handleApplyFilterSimple: Function;
    suggestedTags?: $FixMe;
}

export const TagSuggestions = (props: TagSuggestionsProps) => {
    const handleTagClick = (val: string) => {
        const path = window.location.pathname;
        const pathForTracking = path.replace(/(d\/.*?\/)(.*)/, `$1%23${val}/`);

        props.trackGAEvent?.({
            action: 'BreadcrumbTag',
            label: pathForTracking,
        });

        window.scroll(0, 0);
        props.handleApplyFilterSimple({ q: `#${val}` });
    };

    if (props.suggestedTags.length < 3) {
        return null;
    }

    return (
        <TagGroup
            containerClassName="pivot-section suggested-tags"
            suggestedItems={shuffle(props.suggestedTags)}
            headerText={gettext('Popular tags')}
            render={(tag: { value: string; display: string }) => {
                return (
                    <div className="eds-l-mar-all-1" key={tag.value}>
                        <Tag
                            style="outlined"
                            onActiveToggle={() => handleTagClick(tag.value)}
                        >
                            #{tag.display}
                        </Tag>
                    </div>
                );
            }}
        />
    );
};
